import 'slick-carousel/slick/slick';
import { number } from '@amcharts/amcharts4/core';

$(() => {
    var currentSlideCarousel = 0;
    var currentSlideText = 0;
    var randomSlide = $('.carousel-hero').hasClass('is-random-slide');

    $('.carousel-hero').slick({
        arrows: false,
        dots: true,
        dotsClass: 'carousel-hero-dots no-bullet',
        touchThreshold: 20,
        autoplay: true,
        //initialSlide: 1,
        lazyLoad: 'ondemand',
        respondTo: 'window'
    });

    if (randomSlide) {
        var total = $('.carousel-hero img').length;
        var rand = Math.floor(Math.random() * total);
        $('.carousel-hero').slick('slickGoTo', rand);
    }

    $('.slider-text').slick({
        prevArrow: $('.slider-text-prev-arrow'),
        nextArrow: $('.slider-text-next-arrow'),
        touchThreshold: 20,
    });

    var beforePrint = function () {
        currentSlideCarousel = $('.carousel-hero').slick('slickCurrentSlide');
        currentSlideText = $('.slider-text').slick('slickCurrentSlide');
        $('.carousel-hero').slick('slickFilter', $('.slick-current'));
        $('.slider-text').slick('slickFilter', $('.slick-current'));
    };

    var afterPrint = function () {
        $('.carousel-hero').slick('slickUnfilter');
        $('.carousel-hero').slick('slickGoTo', currentSlideCarousel);
        $('.slider-text').slick('slickUnfilter');
        $('.slider-text').slick('slickGoTo', currentSlideText);
    };

    const newsCarousels = $('.global-news-carousel');
    const autoplaySpeed = Number.parseInt(newsCarousels.data('autoplay-speed') || '2000');

    newsCarousels.slick({
        arrows: false,
        infinite: true,
        dots: false,
        slidesToShow: 3,
        touchThreshold: 20,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,

        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;
});
